import moment from 'moment';

export const STEPS = Object.freeze({
  UPLOAD: 'upload',
  COLUMNS: 'columns',
  SUMMARY: 'summary',
  WRITE: 'write',
});

// Order of the el-steps.
export const STEP_ORDER = Object.freeze([
  STEPS.UPLOAD,
  STEPS.COLUMNS,
  STEPS.SUMMARY,
  STEPS.WRITE,
]);

// How the columns step is populated (REQ-20): `all` when entered automatically
// (unmapped file columns first, then every existing mapping), `file` when
// opened from the summary (only the columns of the file, unmapped first, C59).
export const COLUMNS_MODES = Object.freeze({
  ALL: 'all',
  FILE: 'file',
});

// `columns[].status` of the prepare response.
export const COLUMN_STATUSES = Object.freeze({
  MAPPED: 'mapped',
  UNMAPPED: 'unmapped',
  IGNORED: 'ignored',
});

export function countUnmappedColumns(columns) {
  return columns.filter(({ status }) => status === COLUMN_STATUSES.UNMAPPED)
    .length;
}

// `code` of the prepare FILE_ERROR (422): the file itself has to be fixed.
export const FILE_ERROR_CODES = Object.freeze([
  'error.valueImport.unsupportedFormat',
  'error.valueImport.invalidFile',
  'error.valueImport.invalidLayout',
  'error.valueImport.duplicateColumn',
  'error.valueImport.unnamedColumn',
  'error.valueImport.noSampleCodes',
  'error.valueImport.fileTooLarge',
  'error.valueImport.tooManyRows',
]);

// Dates use the pickers' value-format; the end date defaults to today.
export function createInput() {
  return {
    file: null,
    dateStart: null,
    dateEnd: moment().format('YYYY-MM-DD'),
  };
}

// On the local day, as prepare checks it (Europe/Rome).
export function isFutureDate(date) {
  return moment(date).isAfter(moment(), 'day');
}

// `reference` in the pickers' value-format; no reference, no bound.
export function isBeforeDate(date, reference) {
  return Boolean(reference) && moment(date).isBefore(moment(reference), 'day');
}

// The extension only: the content is checked by prepare.
export function isCsvFileName(name) {
  return /\.csv$/i.test(name);
}

// The server's message, already translated; the client one without a response.
export function serverErrorMessage({ response, message }) {
  const body = response && response.data;
  return (body && body.error && body.error.message) || message;
}

// Error body of a FILE_ERROR response, null for any other error.
function fileErrorBody({ response }) {
  if (!response || response.status !== 422) return null;
  const body = (response.data && response.data.error) || {};
  return FILE_ERROR_CODES.includes(body.code) ? body : null;
}

// Server message of a FILE_ERROR response, null for any other error.
export function fileErrorMessage(error) {
  const body = fileErrorBody(error);
  return body ? body.message : null;
}

// Rows of a rejected file, as a prepare response reports them: only
// noSampleCodes carries them (C60).
export function fileErrorIgnoredRows(error) {
  const body = fileErrorBody(error);
  return (body && body.details && body.details.ignoredRows) || [];
}
